module.exports = __webpack_public_path__ + "static/img/products application_pool1.985bdf15.jpg";